import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Util } from '../../../utils/util';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { MatDialog } from '@angular/material';
import { Parametros } from '../models/parametros';
import { CollectionService } from '../collection.service';
import * as moment from 'moment';

@Component({
	selector: 'app-collection-value-date',
	templateUrl: './value-date.component.html',
	styleUrls: ['./value-date.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CollectionValueAndDateComponent implements OnInit {

	public form: FormGroup;
	public submited = false;
	public parameters: Parametros = new Parametros();
	public minDate = new Date(new Date());
	public maxDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
	public type = 'novo';

	constructor(
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private router: Router,
		private collectionService: CollectionService,
		public dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.getParameters();

		this.route.params.subscribe(params => {
			if (params) {
				this.type = params.type;
			}
		});

		this.buildForm();
	}

	buildForm() {
		const value = this.type === 'novo' ? '' : this.collectionService.getValueToEmit() ;
		const date = this.type === 'novo' ? '' : new Date(this.collectionService.getDateToEmit() + 'T00:00:00');

		this.form = this.formBuilder.group({
			value: [value, [Validators.required, Validators.min(10), Validators.max(9999999999)]],
			date: [date, Validators.required],
		});
	}

	getParameters() {
		this.collectionService.getBilletParameters().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.parameters = Util.keysToCamel(data.Retorno) as Parametros;
				this.generateDatesCalendar();
				this.addValidatorMinAndMax();
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro ao consultar os Parametros necessários, tente novamente mais tarde.' });
			this.goBack();
		});
	}

	addValidatorMinAndMax() {
		this.form.get('value').setValidators([Validators.required, Validators.min(this.parameters.valorMinimoBoleto), Validators.max(9999.00)]);
	}

	generateDatesCalendar() {
		if (this.parameters && this.parameters.datasVencimento && this.parameters.datasVencimento.length > 0) {
			this.minDate = this.parameters.datasVencimento.shift();
			this.maxDate = this.parameters.datasVencimento.pop();
		}
	}

	goBack() {
		this.router.navigate(['cobranca']);
	}

	submit() {
		if (this.form.valid) {
			const date = moment(this.form.get('date').value).format('YYYY-MM-DD');
			const value: number = this.form.get('value').value;

			this.collectionService.setDateToEmit(date);
			this.collectionService.setValueToEmit(value);

			this.router.navigate(['cobranca/resumo-final']);
		}
	}

	validateMinMaxValue(): void {
		const value: number = this.form.get('value').value;

		if (value && value > 0 && value >= this.parameters.valorMinimoBoleto && value <= 9999.00) {
			this.form.get('value').setErrors(null);
			this.form.get('value').updateValueAndValidity();
		} else {
			this.form.get('value').setErrors({'incorrect': true});
			this.form.get('value').updateValueAndValidity();
		}
	}

	removeWeekend = (d: Date): boolean => {
		const day = d.getDay();
		return day !== 0 && day !== 6 ;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/value-date/value-date.component.ts